<template>
    <div class="static-page page">
        <div class="static-page__head">
            <div class="container-xl">                
                <div class="row">
                    <div class="col-12">
                        <h1> {{informationData.name}} </h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-xl-10 offset-xl-1">
                        <div class="short_desc" v-html="informationData.short_description"></div>
                    </div>
                </div>                
            </div>            
        </div>
        <div class="static-page__content">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12">                        
                        <ul class="terms_of_use_ul" v-if="informationData.download">
                            <li v-for="document in informationData.download" :key="document.id" :class="{'noShow': !document.document_id}">
                                <a :href="doc_url + '/' + document.document_id.path + document.document_id.file_name + '?' + aszfTimeStamp" target="_blank" v-if="document.document_id">
                                    {{document.name}}
                                </a>                                
                            </li>                            
                        </ul>
                        <div class="description content_description" v-html="informationData.description">
                        </div>
                    </div>
                </div>
            </div>            
        </div>        
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data(){
        return {
            doc_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME,
            informationData: {},
            contactsArray: [],
            contactInfo: null
        }
    },
    computed:{
        aszfTimeStamp(){
            return  Math.floor( Date.now() /1000)
        }        
    },    
    watch:{
        $route: function(){
            this.getCurrentInformation()
        }
    },
    methods:{
        getCurrentInformation(){     
            let _this = this
            let currentInfoSlug = this.$route.params.info_slug;       

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information/' + currentInfoSlug + '?relations=1&where[0][0]=where&where[0][1]=status&where[0][2]=1&relations_params[download][where][0][0]=where&relations_params[download][where][0][1]=language_status&relations_params[download][where][0][2]=1&relations_params[download][order_by][0][0]=sort_order&relations_params[download][order_by][0][1]=asc',{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {
                
                if (response.data.status == true ){
                    _this.informationData = response.data.information[0]                     
                    _this.setShowContacts()
                    
                } else {
                    _this.$router.push({name: '404-page'})                   
                }                                                          
            })
            .catch((err) => {
                console.log(err)
            });
        },      
        setShowContacts(){
            let _this = this
            let emailItems = document.getElementsByClassName("show_contact");            
            
            setTimeout(()=> {
                // console.log('emailItems', emailItems.length)
                for (var i = 0 ; i < emailItems.length; i++) {
                    emailItems[i].addEventListener('click' , _this.showAddresses , false )
                }
            }, 500)
            

        },
        showAddresses(event){
            // console.log('clickec', event.target)
            // let _this = this
            let clickedItem = event.target
            let contactInfoId = parseInt(clickedItem.getAttribute('data-contact'))
            let contactInfo = null            
            
            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/contact/' + contactInfoId,{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {
                // console.log('contacts: ', response.data); 

                if (response.data.status == true ){                    
                    contactInfo = response.data.contact[0]  
                       
                    if (contactInfo != null){
                        let emailDomain = contactInfo.part2
                        let key = contactInfo.part1
                        let emailAddress = '<a href="mailto:' + key + '@' + emailDomain +'">' + key + '@' + emailDomain + '</a>'
                        
                        clickedItem.innerHTML  = emailAddress
                    }                
                }                                                         
            }).catch((err) => {
                console.log(err)
            });
                                                
        }
    },
    created(){
        this.getCurrentInformation()
    },
    mounted(){
        this.setMetaTags({
            title: 'Univer', 
            desc: this.lang('meta_description_homepage'), 
            keywords:this.lang('meta_keywords_homepage'), 
            ogType: 'website', 
            ogTitle: 'Univer',                         
            ogImage: null, 
            ogImageWidth: null, 
            ogImageHeight: null, 
            ogDesc:this.lang('meta_description_homepage')
        })
    }
}
</script>